import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
  })
  export class EmailNameSpliterService {

    getNameAndEmail(nameAndEmailString: string, searchFromEnd: boolean = false): [string, string] {
        const separatorIndex = searchFromEnd
        ? nameAndEmailString.lastIndexOf("/")
        : nameAndEmailString.indexOf("/");
    
        if (separatorIndex === -1) {
            return;
        }
    
        if (searchFromEnd) {
            const name = nameAndEmailString.substring(0, separatorIndex);
            const email = nameAndEmailString.substring(separatorIndex + 1);
            return [name, email];
        } else {
            const email = nameAndEmailString.substring(0, separatorIndex);
            const name = nameAndEmailString.substring(separatorIndex + 1);
            return [email, name];
        }
    }
        
  }